"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var Background_1 = require("./Background");
var Border_1 = require("./Border");
var Customize_1 = require("./Customize");
var Text_1 = require("./Text");
var Colors = function () { return (react_1.default.createElement(components_1.Doc, { title: "Colors" },
    react_1.default.createElement(Background_1.Background, null),
    react_1.default.createElement(Border_1.Border, null),
    react_1.default.createElement(Text_1.Text, null),
    react_1.default.createElement(Customize_1.ColorsCustomize, null))); };
exports.Colors = Colors;
